module.exports = __webpack_public_path__ + "media/images/personnel/Dawne_A-c56442beb867c667b7a917f65d3533ef.png";